module.exports = __webpack_public_path__ + "img/whatsapp-logo-small.c70cf11f.png";